import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import "react-icons/ai";
import { AiOutlineHome, AiOutlineMessage, AiOutlineUser } from "react-icons/ai";
import { BiCart, BiShoppingBag } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";

import { getAnnouncement } from "../actions/adminActions";
import SearchBar from "./SearchBar";
import { useNavigate } from "react-router-dom";
const Header = () => {
  const [announcement, setAnnouncement] = useState({
    highlight: "Welcome to amy store!",
    text: "Shop now",
  });
  const cart = useSelector((state) => state.cartDetail);
  const admin = useSelector((state) => state.adminDetail);
  const navigate = useNavigate();
  useEffect(() => {
    if (admin.userId) {
      (async function Announce() {
        const data = await getAnnouncement(admin.userId);

        setAnnouncement({
          highlight: data.announcement.highlight,
          text: data.announcement.text,
        });
      })();
    }
  }, [admin.userId]);

  return (
    <div className="header_body">
      <div className="announcement_container">
        {announcement.highlight && <h3>{announcement.highlight}</h3>} {" | "}
        {announcement.text && <p>{announcement.text}</p>}
      </div>
      <div className="main_header_nav">
        <h3
          className="brand_title"
          cursor="pointer "
          onClick={() => navigate("/")}
        >
          Amy Store
        </h3>
        <SearchBar />
        <nav className="header_nav">
          <a className=" header_link home" href="/">
            <AiOutlineHome />
          </a>
          <a className=" header_link chat" href="/chat">
            <AiOutlineMessage />
          </a>
          <a href="/cart" className="header_link cart">
            <span className="cart_count_container">
              {" "}
              {cart?.cartCount !== null ? cart?.cartCount : "0"}
            </span>
            <BiCart />
          </a>
          <a className="header_link user" href="/orders/">
            <span className="cart_count_container">
              {" "}
              {cart?.checkoutCount !== null ? cart?.checkoutCount : "0"}
            </span>
            <BiShoppingBag />
          </a>
          <a
            className="header_link user"
            href={admin?.userId ? "/user/account" : "/login"}
          >
            <AiOutlineUser />
          </a>
        </nav>
      </div>
    </div>
  );
};

export default Header;
